const routes = {
    path: 'expositores',
    name: 'Checkins_Expositores',
    component: () => import('./Listagem.vue'),
    meta: {
        rules: ['EXPOSITOR-00', 'EXPOSITOR-01', 'EXPOSITOR-02', 'EXPOSITOR-03'],
    },
    children: [
        {
            path: ':id/detalhar',
            name: 'Checkins_Expositores_Detalhar',
            component: () => import('./Detalhar.vue'),
            meta: {
                rules: ['EXPOSITOR-01'],
            },
            children: [
                {
                    path: 'participantes/:participanteId',
                    name: 'Checkins_Expositores_Participantes_Detalhar',
                    component: () => import('../participantes/Detalhar.vue'),
                    meta: {
                        rules: ['EXPOSITOR-02'],
                    },
                },
            ],
        },
    ],
};

export default routes;
